import {Link} from 'react-router-dom';

import {ComponentProps, ComponentType, PropsWithChildren} from 'react';
import AssessmentIcon from '@material-ui/icons/Assessment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import {Card, CardContent} from '@/components/ui/card';

function HomeButton({
    children,
    to,
    Icon,
}: PropsWithChildren<{to: ComponentProps<typeof Link>['to']; Icon: ComponentType<any>}>) {
    return (
        <Card className="flex items-center basis-1/3 bg-white hover:bg-primary hover:text-primary-200 transition-all cursor-pointer relative">
            <CardContent className="flex items-center justify-center flex-col gap-y-3">
                <Icon className="!text-6xl" />
                <h2 className="text-xl font-bold">{children}</h2>
            </CardContent>
            <Link to={to} className="absolute top-0 bottom-0 left-0 right-0 z-10"></Link>
        </Card>
    );
}

HomeButton.displayName = 'HomeButton';

export default function Home() {
    return (
        <div className="flex w-full items-center justify-center pt-16">
            <div className="lg:w-[70%] w-full flex lg:flex-row flex-col gap-4">
                <HomeButton to="/agent" Icon={SupervisedUserCircleIcon}>
                    Clients
                </HomeButton>
                <HomeButton to="/case-manager" Icon={AssignmentIndIcon}>
                    Applications
                </HomeButton>
                <HomeButton to="/tools" Icon={AssessmentIcon}>
                    External Tools
                </HomeButton>
            </div>
        </div>
    );
}

Home.displayName = 'Home';
